import { render, staticRenderFns } from "./OrganPersonDescriptionInfoEdit.vue?vue&type=template&id=17e3bdfa&scoped=true"
import script from "./OrganPersonDescriptionInfoEdit.vue?vue&type=script&lang=js"
export * from "./OrganPersonDescriptionInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e3bdfa",
  null
  
)

export default component.exports